import React from 'react';
import { Navigate } from 'react-router-dom';
import { tokenManager } from '../../services/api';

export default function ProtectedRoute({ children }) {
  if (!tokenManager.isAuthenticated()) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}